// src/contexts/TenantContext.js

import React, { createContext, useContext, useEffect, useState } from 'react';
import tenantService from '../services/tenant.service';
import axios from 'axios';

const TenantContext = createContext();

export const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error('useTenant must be used within a TenantProvider');
  }
  return context;
};

export const TenantProvider = ({ children }) => {
  const [tenant, setTenant] = useState(null);
  const [tenantData, setTenantData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    initializeTenant();
  }, []);

  const initializeTenant = async () => {
    try {
      setLoading(true);
      const currentTenant = tenantService.getCurrentTenant();
      setTenant(currentTenant);

      // If it's a tenant domain, fetch tenant data from backend
      if (tenantService.isTenantDomain()) {
        const tenantIdentifier = tenantService.getTenantIdentifier();
      // const response = await axios.get(`/tenant/${tenantIdentifier}`);
        // setTenantData(response.data);
      }
    } catch (err) {
      setError(err.message);
      console.error('Error initializing tenant:', err);
    } finally {
      setLoading(false);
    }
  };

  const value = {
    tenant,
    tenantData,
    loading,
    error,
    isAdminDomain: tenantService.isAdminDomain(),
    isTenantDomain: tenantService.isTenantDomain(),
    tenantIdentifier: tenantService.getTenantIdentifier(),
    refreshTenant: initializeTenant
  };

  return (
    <TenantContext.Provider value={value}>
      {children}
    </TenantContext.Provider>
  );
};